import { useCallback, useState } from 'react'
import type { DiscountCouponCode } from '~/lib/graphql/scalars'
import { useSubmitInputCoupon } from '../../store/discountCoupon'
import { useDiscountCouponType } from '../../store/stateMachine/context'

export function useInputCouponCodeBody() {
  const [couponCode, setCouponCode] = useState<DiscountCouponCode>()
  const couponType = useDiscountCouponType()
  const inputCouponCode = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode(e.target.value as DiscountCouponCode)
  }, [])
  const submitInputCoupon = useSubmitInputCoupon()
  const submit = useCallback(() => {
    submitInputCoupon(couponCode)
  }, [couponCode, submitInputCoupon])
  return { couponType, inputCouponCode, submit }
}
